module.exports = __webpack_public_path__ + "img/MTCIVALL.eec28e6a.png";